import { render, staticRenderFns } from "./FormComponentGroup.vue?vue&type=template&id=19b04642"
import script from "./FormComponentGroup.vue?vue&type=script&lang=js"
export * from "./FormComponentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports